<template>
  <div>
    <el-form
      role="form"
      class=""
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
    >
      <div class="relative">
        <small class="fsize12 bg-white font-medium text-dark"
          >Product Name</small
        >
        <el-form-item prop="productName">
          <el-input
            placeholder="Enter or Type..."
            v-model="ruleForm.productName"
            class="rounded-xl mt-2"
          />
        </el-form-item>
      </div>
      <el-collapse name="1">
        <el-collapse-item title="Product" class="mt-6 collapse-cs" name="1">
          <div class="bg-f4f5f6 p-4 rounded-b-12px">
            <div>
              <small class="fsize12 text-dark font-medium">Tag Name</small>
              <el-form-item prop="tagName">
                <el-select
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  v-model="ruleForm.tagName"
                  placeholder="Enter or Type..."
                  class="w-full mt-2"
                >
                  <el-option
                    v-for="(item, index) in tagsDetails"
                    :key="`${item.tagName}+${index}`"
                    :label="item.tagName"
                    :value="item.tagName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div class="mt-4">
              <small class="fsize12 text-dark font-medium">Category</small>
              <el-form-item prop="categoryName">
                <el-select
                  multiple
                  v-model="ruleForm.categoryName"
                  placeholder="Enter or Type..."
                  class="w-full mt-2"
                >
                  <el-option
                    v-for="(item, index) in detailedCategory"
                    :key="`${item.categoryName}+${index}`"
                    :label="item.categoryName"
                    :value="item.categoryName"
                  >
                  </el-option> </el-select
              ></el-form-item>
            </div>

            <div class="mt-4">
              <small class="fsize12 text-dark font-medium">Sub-Category</small>
              <el-form-item prop="subCategoryName">
                <el-select
                  multiple
                  v-model="ruleForm.subCategoryName"
                  placeholder="Enter or Type..."
                  class="w-full mt-2"
                >
                  <el-option
                    v-for="(item, index) in detailedCategory"
                    :key="`${item.categoryName}+${index}`"
                    :label="item.categoryName"
                    :value="item.categoryName"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="mt-4">
        <small class="fsize12 text-dark font-medium">Attribute Name</small>
        <el-form-item prop="primaryAttribute">
          <el-select
            filterable
            allow-create
            default-first-option
            v-model="ruleForm.primaryAttribute"
            placeholder="Enter or Select..."
            class="w-full mt-2"
            disabled
          >
            <el-option
              class="option-bgchange"
              v-for="(item, index) in EcomAttrinutes"
              :key="`${item.name}+${index}`"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-input
            v-if="productDetail.attributesId"
            v-model="productDetail.attributesId[0].name"
            class="rounded-xl mt-2"
            disabled
          /> -->
      </div>

      <div class="mt-4">
        <small class="fsize12 text-dark font-medium">Variation Name</small>
        <el-form-item prop="secondaryAttribute">
          <el-select
            filterable
            allow-create
            default-first-option
            v-model="ruleForm.secondaryAttribute"
            placeholder="Enter or Select..."
            class="w-full mt-2"
            disabled
          >
            <el-option
              class="option-bgchange"
              v-for="(item, index) in EcomAttrinutes"
              :key="`${item.name}+${index}`"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-input
            v-if="productDetail.attributesId.length == 2"
            v-model="productDetail.attributesId[1].name"
            class="rounded-xl mt-2"
            disabled
          /> -->
      </div>
      <div class="relative mt-8">
        <small class="fsize12 bg-white font-medium text-dark">HSN Code</small>
        <el-form-item prop="HSNCode">
          <el-input
            placeholder="Enter or HSN Code..."
            v-model="ruleForm.HSNCode"
            class="rounded-xl mt-2"
          />
        </el-form-item>
      </div>
      <div class="relative mt-4">
        <small class="fsize12 bg-white font-medium text-dark">GST</small>
        <el-form-item prop="GST">
          <el-input
            placeholder="Enter GST %..."
            v-model="ruleForm.GST"
            class="rounded-xl mt-2"
            :maxlength="2"
          />
        </el-form-item>
      </div>
      <div class="mt-8">
        <div class="w-full">
          <h3 class="text-4f4f4f text-xl font-semibold mb-0">
            Add Product Description
          </h3>
          <p class="fsize12 font-medium mb-0 mt-2 text-8f8f8f">
            State some unique selling points
          </p>
        </div>

        <div class="relative mt-3">
          <small class="fsize12 bg-white text-dark font-medium">Overview</small>
          <el-form-item prop="description">
            <el-input
              type="textarea"
              class="mt-2"
              :autosize="{ minRows: 6, maxRows: 6 }"
              placeholder="Description"
              v-model="ruleForm.description"
            >
            </el-input>
          </el-form-item>
        </div>

        <div class="mt-3">
          <small class="fsize12 bg-white text-dark font-medium"
            >Description</small
          >
          <vue-editor class="quill-height mt-2" v-model="detailDescription" />
        </div>

        <div class="w-full flex justify-between items-center mt-8">
          <div>
            <h3 class="text-4f4f4f text-xl font-semibold mb-0">Create Table</h3>
            <p class="fsize12 font-medium mb-0 mt-2 text-8f8f8f">
              Create Table for product Information
            </p>
          </div>

          <vs-button
            v-if="additionDetail.length < 2"
            variant="primary"
            class="rounded-lg bg-primary border-0 text-white font-semibold py-2 px-4 sm-fsize14"
            @click="createTable"
          >
            Create Table
          </vs-button>
        </div>
        <div v-for="(table, index) in additionDetail" :key="'table' + index">
          <div class="relative mt-8">
            <div class="w-full flex justify-between items-center">
              <small class="fsize12 bg-white font-medium text-dark"
                >Table Name</small
              >
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                @click="removeTable(additionDetail, index)"
              />
            </div>
            <el-input
              placeholder="Table Name"
              v-model="table.table"
              class="rounded-xl mt-2"
            />
          </div>
          <div
            class="w-full flex items-end mt-2"
            v-for="(element, index) in table.value"
            :key="'element' + index"
          >
            <div class="w-11/12 flex gap-2 items-center">
              <div class="relative">
                <small class="fsize12 bg-white font-medium text-dark">
                  Name</small
                >
                <el-input
                  placeholder="Name"
                  v-model="element.name"
                  class="rounded-xl mt-2"
                />
              </div>
              <div class="relative">
                <small class="fsize12 bg-white font-medium text-dark"
                  >Description
                </small>
                <el-input
                  placeholder="Description"
                  v-model="element.description"
                  class="rounded-xl mt-2"
                />
              </div>
            </div>
            <div
              class="w-1/12 flex justify-end"
              @click="deleteRow(table.value, index)"
            >
              <feather-icon icon="MinusCircleIcon" />
            </div>
          </div>
          <div class="w-full flex justify-between items-center mt-4">
            <p
              class="fsize14 text-primary items-center cursor-pointer flex gap-2 font-semibold"
              @click="addRow(table.value)"
            >
              <feather-icon icon="PlusIcon" svgClasses="w-4 h-4" />Add
            </p>
            <!-- <p class="fsize14 text-gray">Maximum upto 8</p> -->
          </div>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-8">
        <vs-button
          type="primary"
          class="bg-primary rounded-lg font-semibold py-4 fsize14"
          @click="handleSubmit('ruleForm')"
          >Save</vs-button
        >

        <vs-button
          type="secondary"
          class="bg-secondary rounded-lg font-semibold py-4 fsize14"
          @click="closePopup"
          >Cancel</vs-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { VueEditor } from "vue2-quill-editor";
import FeatherIcon from "../../../../../../components/FeatherIcon.vue";
import { getRandomValues } from "crypto";
export default {
  data() {
    return {
      FeatherIconFeatherIconactiveNames: "1",
      // subCategoryName: [],
      // categoryName: [],
      // tagName: [],
      // productName: "",
      // description: "",
      // HSNCode: "",
      // GST: "",
      // secondaryAttribute: "",
      // primaryAttribute: "",
      //   att1: "",
      //   att2: "",
      detailDescription: "",
      additionDetail: [],
      productId: null,

      ruleForm: {
        subCategoryName: [],
        categoryName: [],
        tagName: [],
        productName: "",
        description: "",
        HSNCode: "",
        GST: "",
        secondaryAttribute: "",
        primaryAttribute: "",
        // att1: "",
        // att2: "",
        // detailDescription: "",
      },
      rules: {
        subCategoryName: [
          {
            type: "array",
            required: true,
            message: "Please Select SubCategory",
            trigger: "blur",
          },
        ],
        categoryName: [
          {
            type: "array",
            required: true,
            message: "Please Select Category",
            trigger: "blur",
          },
        ],
        tagName: [
          {
            type: "array",
            required: true,
            message: "Please Select Tag",
            trigger: "blur",
          },
        ],
        productName: [
          {
            required: true,
            message: "Please Enter Product Name",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Please Enter Description",
            trigger: "blur",
          },
        ],
        HSNCode: [
          {
            required: true,
            message: "Please Enter HSN Code",
            trigger: "blur",
          },
          {
            pattern: /^\d{1,8}$/,
            message: "HSN Code should be numeric and only be of max 8 char",
            trigger: "blur",
          },
        ],
        GST: [
          {
            required: true,
            message: "Please Enter GST",
            trigger: "blur",
          },
          {
            pattern: /^\d{1,2}$/,
            message: "GST should be numeric",
            trigger: "blur",
          },
        ],
        secondaryAttribute: [
          {
            required: true,
            message: "Please Enter Variation Name",
            trigger: "blur",
          },
        ],
        primaryAttribute: [
          {
            required: true,
            message: "Please Enter Attribute Name",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    editProduct: {
      type: Object,
      required: true,
    },
    EditProductPopup: {
      type: Boolean,
    },
  },
  components: {
    VueEditor,
  },
  watch: {
    EditProductPopup(val) {
      if (val == true) {
        this.resetForm("ruleForm");
        this.populateData();
      } else {
        this.resetData();
      }
    },
  },
  methods: {
    handleSubmit(formName) {
      this.ruleForm.productName = this.ruleForm.productName.trim();
      this.ruleForm.description = this.ruleForm.description.trim();
      this.ruleForm.HSNCode = this.ruleForm.HSNCode.trim();
      this.ruleForm.GST = this.ruleForm.GST.trim();
      this.ruleForm.secondaryAttribute =
        this.ruleForm.secondaryAttribute.trim();
      this.ruleForm.primaryAttribute = this.ruleForm.primaryAttribute.trim();

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleEditProduct();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      this.ruleForm.categoryName = [];
      this.ruleForm.tagName = [];
      this.ruleForm.subCategoryName = [];
      this.ruleForm.productName = "";
      this.ruleForm.description = "";
      this.detailDescription = "";
      this.additionDetail = [];
      this.ruleForm.GST = "";
      this.ruleForm.HSNCode = "";
      this.ruleForm.primaryAttribute = "";
      this.ruleForm.secondaryAttribute = "";
    },
    closePopup() {
      this.$emit("closePopup");
    },
    createTable() {
      // console.log(this.additionDetail.length);
      // if (this.additionDetail.length >= 2) {
      //   return this.$swal({
      //     text: `Only two table is allowed!`,
      //     icon: "warning",
      //     zIndex: "9999 !important",
      //   });
      // return alert("only two table is allowed!");
      // }
      this.additionDetail.push({
        table: "",
        value: [{ name: "", description: "" }],
      });
    },
    removeTable(table, index) {
      table.splice(index, 1);
    },
    addRow(tableValue) {
      // if (tableValue.length >= 8) {
      //   return this.$swal({
      //     text: `Only 8 rows is allowed!`,
      //     icon: "warning",
      //   });
      // return alert("only 8 rows is allowed!");
      // }
      tableValue.push({ name: "", description: "" });
    },
    deleteRow(tableValue, index) {
      // console.log(tableValue, index);
      tableValue.splice(index, 1);
    },
    async loadData() {
      await this.$store.dispatch("tags/getTags");
      await this.$store.dispatch("EcomAttributes/getAttributes");
      await this.$store.dispatch("EcomCategory/getDetailedCategory");
    },
    // test() {
    //   let additionDetailPayload = {};

    //   for (let data = 0; data < this.additionDetail.length; data++) {
    //     additionDetailPayload[this.additionDetail[data].table] =
    //       this.additionDetail[data].value;
    //   }
    //   console.log(additionDetailPayload);
    // },
    async handleEditProduct() {
      //   let attributeName = [];
      //   attributeName.push(this.att1);
      //   attributeName.push(this.att2);
      //   console.log(attributeName);

      let additionDetailPayload = {};
      for (let data = 0; data < this.additionDetail.length; data++) {
        additionDetailPayload[this.additionDetail[data].table] =
          this.additionDetail[data].value;
      }

      const payload = {
        categoryName: this.ruleForm.categoryName,
        tagName: this.ruleForm.tagName,
        subCategoryName: this.ruleForm.subCategoryName,
        productName: this.ruleForm.productName,
        description: this.ruleForm.description,
        detailDescription: this.detailDescription,
        additionalDetail: additionDetailPayload,
        GST: this.ruleForm.GST,
        HSNCode: this.ruleForm.HSNCode,
        productId: this.productId,
        // attributeName: attributeName,
      };
      let loader;
      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let data = await this.$store.dispatch(
          "EcomProduct/editProduct",
          payload
        );
        if (data.code === 200) {
          await this.$store.dispatch("EcomProduct/getAllProduct");
          loader.close();
          this.$emit("closePopup");
          await this.$swal({
            title: `Product updated successfully!`,
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          this.resetData();
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
        await this.$swal({
          title: `Failed to update the product!`,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
      }

      //   this.categoryName = [];
      //   this.tagName = [];
      //   this.subCategoryName = [];
      //   this.productName = "";
      //   this.description = "";
      //   this.detailDescription = "";
      //   this.additionDetail = [];
      //   this.GST = "";
      //   this.HSNCode = "";
      //   this.primaryAttribute = "";
      //   this.secondaryAttribute = "";
    },
    // async addAttributePrm() {
    //   let payload = {
    //     name: this.primaryAttribute,
    //   };
    //   let { data } = await this.$store.dispatch(
    //     "EcomAttributes/addAttributes",
    //     payload
    //   );
    //   this.att1 = data._id;
    // },
    // async addAttributeSec() {
    //   let payload = {
    //     name: this.secondaryAttribute,
    //   };
    //   let { data } = await this.$store.dispatch(
    //     "EcomAttributes/addAttributes",
    //     payload
    //   );
    //   this.att2 = data._id;
    // },
    populateData() {
      console.log(this.editProduct, "editProduct");
      if (this.editProduct && this.editProduct.tagId.length !== 0) {
        this.ruleForm.tagName = this.editProduct.tagId.map(
          (tag) => tag.tagName
        );
      }
      if (this.editProduct && this.editProduct.subcatName.length !== 0) {
        this.ruleForm.subCategoryName = this.editProduct.subcatName.map(
          (subcat) => subcat.categoryName
        );
      }
      if (this.editProduct && this.editProduct.categoryName.length !== 0) {
        this.ruleForm.categoryName = this.editProduct.categoryName.map(
          (category) => category.categoryName
        );
      }
      if (
        this.editProduct &&
        this.editProduct.additionalDetail !== null &&
        this.editProduct.additionalDetail !== undefined &&
        !this.isObjectEmpty(this.editProduct.additionalDetail)
      ) {
        let entries = Object.entries(this.editProduct.additionalDetail);
        this.additionDetail = entries.map(([key, val] = entry) => {
          return {
            table: key,
            value: val,
          };
        });
      }
      if (this.editProduct && this.editProduct.productName) {
        this.ruleForm.productName = this.editProduct.productName;
      }
      if (this.editProduct && this.editProduct.description) {
        this.ruleForm.description = this.editProduct.description;
      }
      if (this.editProduct && this.editProduct.detailDescription) {
        this.detailDescription = this.editProduct.detailDescription;
      }
      if (this.editProduct && this.editProduct.GST) {
        this.ruleForm.GST = this.editProduct.GST;
      }
      if (this.editProduct && this.editProduct.HSNCode) {
        this.ruleForm.HSNCode = this.editProduct.HSNCode;
      }
      if (
        this.editProduct &&
        this.editProduct.attributesId.length !== 0 &&
        this.editProduct.attributesId[0]
      ) {
        this.ruleForm.primaryAttribute = this.editProduct.attributesId[0].name;
      }
      if (
        this.editProduct &&
        this.editProduct.attributesId.length !== 0 &&
        this.editProduct.attributesId[1]
      ) {
        this.ruleForm.secondaryAttribute =
          this.editProduct.attributesId[1].name;
      }
      if (this.editProduct && this.editProduct._id) {
        this.productId = this.editProduct._id;
      }
    },
    resetData() {
      this.ruleForm.tagName = [];
      this.ruleForm.subCategoryName = [];
      this.ruleForm.categoryName = [];
      this.ruleForm.productName = "";
      this.ruleForm.description = "";
      this.detailDescription = "";
      this.additionDetail = [];
      this.ruleForm.GST = "";
      this.ruleForm.HSNCode = "";
      this.ruleForm.primaryAttribute = "";
      this.ruleForm.secondaryAttribute = "";
      this.productId = null;
    },
    isObjectEmpty(objectName) {
      return (
        objectName &&
        Object.keys(objectName).length === 0 &&
        objectName.constructor === Object
      );
    },
  },
  mounted() {
    this.loadData();
    // console.log(this.EcomCategory, "cateddd");
    // console.log(this.detailedCategory, "dettttt");
    this.populateData();
  },
  computed: {
    ...mapState("tags", ["tagsDetails"]),
    ...mapState("EcomAttributes", [
      "EcomAttrinutes",
      "singleAttrinutesPrime",
      "singleAttrinutesSec",
    ]),
    ...mapState("EcomCategory", ["EcomCategory", "detailedCategory"]),
  },
};
</script>

<style>
.swal2-container {
  z-index: 9999 !important;
}
</style>
